<template>
  <component :is="component"></component>
</template>
<script>

import Func50 from '@/views/50/Func50Listagem'

export default {
  name: 'Func10',
  data () {
    return {
      component: Func50
    }
  }
}
</script>
